
import { activeSync } from '../api.js'

import notifications from '../notifications.js'

async function _getAllData(scheduleRequestId, newStatus) {
  try {
    let response = await activeSync.getScheduleRequestAllData(scheduleRequestId, { status: newStatus })
    return response.data
  }
  catch (error) {
    notifications.pushError(`Active sync data failed to load! ${error.response.data.error}`, error)
  }
}

async function _updateStatus(scheduleRequestId) {
  try {
    await activeSync.postScheduleRequestStatusUpdate(scheduleRequestId)
  }
  catch (error) {
    notifications.pushError(`Failed to update request status! ${error.response.data.error}`, error)
  }
}

async function _setRoutePullScheduleRequest(scheduleRequestId, value) {
  try {
    let response = await activeSync.postSetRoutePullScheduleRequest(scheduleRequestId, { value: value })
    return response.data
  }
  catch (error) {
    notifications.pushError(`Failed to update request route pull status! ${error.response.data.error}`, error)
  }
}

async function _setScheduleRequestStatus(scheduleRequestId, newStatus) {
  try {
    let response = await activeSync.postScheduleRequestStatusUpdate(scheduleRequestId, { status: newStatus })
    if (response.status == 200) {
      return true
    }
    else {
      return false
    }
  }
  catch (error) {
    notifications.pushError(`Failed to update request status! ${error.response.data.error}`, error)
  }
}

export default {
  getAllData: _getAllData,
  updateStatus: _updateStatus,

  setScheduleRequestStatus: _setScheduleRequestStatus,
  setRoutePullScheduleRequest: _setRoutePullScheduleRequest,
}
